import { useContext } from "react";
import ModalUtilContext from "../contexts/modalUtil";

export const useModalUtil = () => {
  return useContext(ModalUtilContext);
};
